import single from "./single"
import page from "./page";

const templates = {
    page: page,
    single: single,
}

export default templates;